<div class="create-interactive">
    <div class="create-interactive__exit">
        <button type="button" routerLink="../">
            <span class="icon-anchor-top"></span>
            <span>Exit</span>
        </button>
    </div>

    <h3 class="create-interactive__title">Create New Interactive</h3>

    <app-interactive-form
        [isSubmitting]="submitting()"
        (formSubmit)="onSubmit($event)"
    ></app-interactive-form>
</div>
